<button tdWbIconButton
        tdWbIconButtonShape="circle"
        tdWbIconButtonSize="extra-small"
        tdWbIconButtonBackground="clear-tint"
        [tdWbOverlayToggle]="externalOverlayTemplate() ?? tooltipTemplate"
        [tdWbOverlayPosition]="tooltipPosition()"
        [tdWbOverlaySize]="tooltipSize()"
        [attr.aria-label]="resolvedAriaLabel()"
        [attr.aria-describedby]="ariaDescribedBy()">
  <td-wb-icon [iconId]="iconId()"
              [size]="iconSize()" />
</button>

<ng-template #tooltipTemplate>
  <td-wb-overlay>
    <span class="td-wb-tooltip-button__text" [textContent]="tooltipText()"></span>
  </td-wb-overlay>
</ng-template>

